// auth action types
// export const CHECK = 'AUTH_CHECK';
// export const LOGIN = 'AUTH_LOGIN';
// export const LOGOUT = 'AUTH_LOGOUT';
// export const RESET_PASSWORD = 'AUTH_RESET_PASSWORD';
// export const USER = 'AUTH_USER';

export const LOGIN_REQUESTING = 'LOGIN_REQUESTING'
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS'
export const LOGIN_FAILURE = 'LOGIN_FAILURE'
export const LOGOUT = 'LOGOUT'

export default {
  LOGIN_REQUESTING,
  LOGIN_SUCCESS,
  LOGIN_FAILURE,
  LOGOUT,
};
